<script setup>
import ResultOrganism from '@/components/organisms/ResultOrganism.vue';
import CanvasTemplate from '@/components/templates/CanvasTemplate.vue';
import levenshtein from 'js-levenshtein';
import { ref } from 'vue';

let questions = [
  { word: "die Katze", audio: "/audio/die_katze.mp3" },
  { word: "das glänzende Fahrrad", audio: "/audio/das_fahrrad.mp3" },
  { word: "die prachtvolle Gouvernante", audio: "/audio/die_gouvernante.mp3", result: null },
];

const showOverlay = ref(false)
const showResult = ref(false)


let question_index = ref(0)
let question = ref(questions[0]);

const handleDoneClicked = () => {
  showOverlay.value = true
}

const handleResult = (r) => {
  const distance = levenshtein(r, question.value.word)

  questions[question_index.value].result = {
    text: r,
    distance: distance
  };

  if (question_index.value >= questions.length - 1) {
    showResult.value = true
    showOverlay.value = false
    return
  }

  question_index.value = question_index.value + 1;
  question.value = questions[question_index.value]

  showOverlay.value = false
}



</script>

<template>
  <div class="question">
    <div class="word">
      {{ question.word }}
    </div>
    <CanvasTemplate :question="question" @result="handleResult" @done="handleDoneClicked" :key="question_index" />
  </div>
  <div class="overlay" v-if="showOverlay">
    Lade nächstes Wort ...
  </div>

  <div class="result" v-if="showResult">
    <ResultOrganism :questions="questions" />
  </div>
</template>


<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 40px;
  color: #fff;
}

.result {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 40px;
  color: #fff;

  .modal {
    width: 50vw;
    height: 50vh;

    background-color: #fff;

    .result_word {
      font-size: 14px;
      color: #000;
    }
  }
}

.question {
  width: 100%;
  height: 100%;
  border: solid 1px red;
  display: flex;
  flex-direction: column;
}

.word {
  height: 250px;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.6);
}
</style>
